import React, { useRef } from 'react';
import { TouchableOpacity, Animated, StyleSheet } from 'react-native';
import { useTheme } from '../../../theme/useTheme';

interface AdminToggleProps {
  value: boolean;
  onChange: (val: boolean) => void;
  disabled?: boolean;
}

const AdminToggle: React.FC<AdminToggleProps> = ({ value, onChange, disabled }) => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';

  const anim = useRef(new Animated.Value(value ? 1 : 0)).current;

  const handlePress = () => {
    if (disabled) return;
    const next = !value;
    Animated.timing(anim, {
      toValue: next ? 1 : 0,
      duration: 180,
      useNativeDriver: false,
    }).start();
    onChange(next);
  };

  const trackColor = anim.interpolate({
    inputRange: [0, 1],
    outputRange: [isDark ? '#4A4A4A' : '#A8A8A8', '#129F14'],
  });

  const thumbLeft = anim.interpolate({
    inputRange: [0, 1],
    outputRange: [2, 18],
  });

  return (
    <TouchableOpacity activeOpacity={0.8} onPress={handlePress} disabled={disabled}>
      <Animated.View style={[styles.track, { backgroundColor: trackColor }]}>
        <Animated.View style={[styles.thumb, { left: thumbLeft }, isDark && { backgroundColor: '#E0E0E0' }]} />
      </Animated.View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  track: {
    width: 34,
    height: 18,
    borderRadius: 9,
    justifyContent: 'center',
  },
  thumb: {
    position: 'absolute',
    width: 14,
    height: 14,
    borderRadius: 7,
    backgroundColor: '#FFFFFF',
    top: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.2,
    shadowRadius: 1,
    elevation: 2,
  },
});

export default AdminToggle;
